module.exports = __webpack_public_path__ + "img/JiouFenBanner.bea83b45.png";